import { useEffect, useState } from "react";
import WodaGrupoweTHead from "./WodaGrupoweTHead";
import WodaGrupoweTBody from "./WodaGrupoweTBody";
import WodaGrupowePodsumowanie from "./WodaGrupowePodsumowanie";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { dataFormat2 } from "../../../functions/dataFormat";

const WodaGrupowe = props => {

    const { wybranaWspolnota, mieszkancy, ulice, lokale, users, grupy, odczyty, planowaneZuzycie, udzialyKontaAkt, czyWybranaWspolnota } = props;                   

    const [tablica, setTablica] = useState([]);
    const [daty, setDaty] = useState({dataOd: "", dataDo: ""});
    const [uzupelnione, setUzupelnione] = useState([]);

    useEffect( () => {
        const temp = udzialyKontaAkt?.map( (udzial, i) => {
            return ({
                id: i,
                id_user: udzial?.id_user,
                grupa_numer: udzial?.grupa_numer,
                czy_wybrany: true,
                czy_aktualizacja: false, 
                zimna_poczatek: 0,
                zimna_koniec: 0,
                ciepla_poczatek: 0,
                ciepla_koniec: 0,
                zimna_zuzycie: 0,
                ciepla_zuzycie: 0
            })
        })
        setTablica(temp);
    },[ udzialyKontaAkt, mieszkancy, wybranaWspolnota ]);
    
    useEffect( () => setUzupelnione( odczyty?.filter( o => daty.dataOd !== '' && dataFormat2(o.okres_poczatek) == daty.dataOd) ), [odczyty, daty.dataOd, wybranaWspolnota]);
    useEffect( () => setDaty({dataOd: "", dataDo: ""}), [wybranaWspolnota]);
    
    useEffect( () => {  
        if (uzupelnione?.length > 0) {
            const temp = tablica?.map( obj => {
                const podmiana = uzupelnione?.find( u => u?.id_user == obj?.id_user && u?.grupa_numer == obj?.grupa_numer);
                const podmianaZestaw = podmiana && ({
                    id: obj.id,
                    id_odczytu: podmiana.id,
                    id_user: obj.id_user,
                    grupa_numer: obj.grupa_numer,
                    czy_wybrany: true,
                    czy_aktualizacja: true,
                    zimna_poczatek: podmiana.zimna_stan_poczatek,
                    zimna_koniec: podmiana.zimna_stan_koniec,
                    ciepla_poczatek: podmiana.ciepla_stan_poczatek,
                    ciepla_koniec: podmiana.ciepla_stan_koniec,
                    zimna_zuzycie: podmiana.zimna_stan_koniec - podmiana.zimna_stan_poczatek,
                    ciepla_zuzycie: podmiana.ciepla_stan_koniec - podmiana.ciepla_stan_poczatek
                })
                return podmianaZestaw || obj;
            })
            setTablica(temp);
        }
    },[uzupelnione, wybranaWspolnota])
    
    return (
        <div className="woda-content-grupowe">
            <div className="table-container">
                <p>
                    <FontAwesomeIcon 
                        icon={faCircleInfo} 
                    />
                    <span>
                        Aby efektywniej przechodzić między polami, używaj klawisza Tab oraz Tab+Shift.<br/>
                        <b>Zacznij od wpisania daty początkowej</b> - program sprawdzi, czy mieszkańcy nie mają juz wprowadzonych zużyć w okresie.
                    </span>
                </p>
                <table className="lista tabela zbiorowka">
                    <WodaGrupoweTHead />
                    <WodaGrupoweTBody
                        mieszkancy={mieszkancy}
                        ulice={ulice}
                        lokale={lokale}
                        users={users}
                        grupy={grupy}
                        udzialyKontaAkt={udzialyKontaAkt}
                        odczyty={odczyty}
                        planowaneZuzycie={planowaneZuzycie}
                        tablica={tablica}
                        setTablica={setTablica}
                        uzupelnione={uzupelnione}
                    />
                </table>
            </div>
            <WodaGrupowePodsumowanie
                tablica={tablica}
                daty={daty}
                setDaty={setDaty}
                wybranaWspolnota={wybranaWspolnota}
                czyWybranaWspolnota={czyWybranaWspolnota}
            />
        </div>
    )
}

export default WodaGrupowe;